<div class="wrapper__headerComponent container my-5">
  <div class="row">
    <div class="d-flex flex-row align-items-start">
      <img
        src="../../../../assets/img/file-alt.svg"
        alt="logo"
        class="img-ico-form" />
      <h2 class="mb-0">
        {{ 'tramites.tramite-dimar.titulo' | translate: { proceso: proceso, entidad: entidad } }}
      </h2>
    </div>
  </div>
  <app-recuadro-justino></app-recuadro-justino>
  <div
    [formGroup]="proceeding"
    class="wrapper__form__content container mt-5 border__form">
    <div class="wrapper__form">
      <form [formGroup]="formularioInicial">
        <div class="row mb-3">
          <div class="col-12">
            <div class="form-group">
              <label for="tipoSolicitante" class="form-label text3-tipografia-govco"
              >{{'tramites.tramite-dimar.tipo-solicitante' | translate}}</label
              ><span class="text-danger"> *</span>
              <select
                formControlName="tipoSolicitante"
                class="form-select"
                type="text"
                id="tipoSolicitante"
                (change)="validarSolicitante($event)"
                [ngClass]="{
              'is-invalid':
                formularioInicial.get('tipoSolicitante')?.invalid &&
                formularioInicial.get('tipoSolicitante')?.touched,
              autocompleted:
                formularioInicial.get('tipoSolicitante')?.value &&
                formularioInicial.get('tipoSolicitante')?.pristine,
            }">
                <option disabled selected value="">
                  {{ 'tramites.seleccione-opcion' | translate}}
                </option>
                <option *ngFor="let item of tiposSolicitante" [value]="item.Id">
                  {{ item.Valor}}
                </option>
              </select>
              <div
                *ngIf="
              formularioInicial.get('tipoSolicitante')?.invalid &&
              formularioInicial.get('tipoSolicitante')?.touched
            ">
                <div
                  *ngIf="formularioInicial.get('tipoSolicitante')?.errors?.['required']"
                  class="invalid-feedback">
                  {{ 'tramites.tramite-dimar.tipo-solicitante-required' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <!-- Datos del investigado -->
      <div *ngIf="!mostrarParteInteresada">
        <div class="row">
          <div
            class="d-flex flex-column flex-xl-row align-items-xl-center mb-4 justify-content-between">
            <h4 class="wrapper__form__title mb-0">
              {{ dimarText['tramite-dimar']['datos-investigado'] }}
              {{
                tipoPersona == 'persona natural'
                  ? comunText['persona-natural']
                  : comunText['persona-juridica']
              }}
            </h4>
            <p class="m-0 text3-tipografia-govco wrapper__form__camposObligatory">
            <span class="text-danger">*</span
            >{{ dimarText['campos-obligatorios'] }}
            </p>
          </div>
        </div>
        <app-persona
          [showTypePerson]="true"
          [aditionalText]="'donde se hace la solicitud'"
          [showAditionalText]="true"
          [countries]="countries"
          [documentTypeList]="documentTypeList"
          [documentTypeListJuridica]="documentTypeListJuridica"
          [dataLogin]="dataUsuario"
          [isDimar]="true"
          (formData)="handleFormData($event)"
          [values]="dataDemandado"
          [isApoderado]="false">
        </app-persona>
      </div>
      <!-- Datos de la parte interesada -->
      <div class="row" *ngIf="mostrarParteInteresada">
        <div
          class="d-flex flex-column flex-xl-row align-items-xl-center mb-4 justify-content-between">
          <h4 class="wrapper__form__title mb-0">
            {{
            tipoPersonaInteresado == 'persona natural'
              ? dimarText['tramite-dimar']['interesado-natural']
              : dimarText['tramite-dimar']['interesado-juridica']
            }}
          </h4>
          <p class="m-0 text3-tipografia-govco wrapper__form__camposObligatory">
            <span class="text-danger">*</span>
            {{ dimarText['campos-obligatorios'] }}
          </p>
        </div>

        <app-persona
          [showTypePerson]="true"
          [countries]="countries"
          [aditionalText]="'donde se hace la solicitud'"
          [showAditionalText]="true"
          [documentTypeList]="documentTypeList"
          [documentTypeListInteresada]="documentTypeListInteresada"
          [documentTypeListJuridica]="documentTypeListJuridica"
          [isDimar]="true"
          (formData)="handleFormDataInterested($event)"
          [values]="dataInteresado"
          [isApoderado]="false"
          [isParteInteresada]="true">
        </app-persona>
      </div>
      <!-- Datos del apoderado -->
      <div class="row">
        <div
          class="d-flex flex-column flex-xl-row align-items-xl-center mb-4 justify-content-between">
          <h4 class="wrapper__form__title mb-0">
            {{ dimarText['tramite-dimar']['apoderado'] }}
          </h4>
          <p class="m-0 text3-tipografia-govco wrapper__form__camposObligatory">
            <span class="text-danger">*</span>
            {{ dimarText['campos-obligatorios'] }}
          </p>
        </div>
      </div>
      <app-persona-abogado
        [countries]="countries"
        [documentTypeListApoderado]="documentTypeListApoderado"
        [isDimar]="true"
        (formData)="handleFormDataAttorney($event)"
        [values]="dataApoderado"
        [autocompleted]="false"
        [dataLogin]="dataUsuario"
        [isApoderado]="true">
      </app-persona-abogado>
      <!-- <app-persona
        [showTypePerson]="false"
        [countries]="countries"
        [documentTypeListApoderado]="documentTypeListApoderado"
        [isDimar]="true"
        (formData)="handleFormDataAttorney($event)"
        [values]="dataApoderado"
        [autocompleted]="false"
        [dataLogin]="dataUsuario"
        [isApoderado]="true">
      </app-persona>-->
      <!-- Tarjeta profesional y teléfono del apoderado -->
      <form [formGroup]="apoderadoForm">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label
                for="numeroTarjetaProfesional"
                class="form-label text3-tipografia-govco">
                {{comunText['tarjeta-profesional'] }}
              </label>
              <input
                type="text"
                class="form-control"
                id="numeroTarjetaProfesional"
                formControlName="numeroTarjetaProfesional"
                [placeholder]="comunText['tarjeta-profesional']"
                autocomplete="off"
                [ngClass]="{
                  'is-valid':
                    apoderadoForm.get('numeroTarjetaProfesional')?.valid &&
                    apoderadoForm.get('numeroTarjetaProfesional')?.touched,
                  'is-invalid':
                    apoderadoForm.get('numeroTarjetaProfesional')?.invalid &&
                    apoderadoForm.get('numeroTarjetaProfesional')?.touched,
                }"/>
              <div
                *ngIf="
                  apoderadoForm.get('numeroTarjetaProfesional')?.invalid &&
                  (apoderadoForm.get('numeroTarjetaProfesional')?.dirty ||
                    apoderadoForm.get('numeroTarjetaProfesional')?.touched)
                ">
              <span *ngIf="apoderadoForm.get('numeroTarjetaProfesional')?.errors?.['minlength']"
                    class="invalid-feedback">
              {{'tramites.tramite-dnda.numero-tarjeta-profesional-minlength' | translate}}
              </span>
                <span *ngIf="apoderadoForm.get('numeroTarjetaProfesional')?.errors?.['maxlength']"
                      class="invalid-feedback">
              {{'tramites.tramite-dnda.numero-tarjeta-profesional-maxlength' | translate}}
              </span>
                <span *ngIf="apoderadoForm.get('numeroTarjetaProfesional')?.errors?.['pattern']"
                      class="invalid-feedback">
                {{'tramites.tramite-dnda.numero-tarjeta-profesional-pattern' | translate}}
              </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label
                for="telefonoApoderado"
                class="form-label text3-tipografia-govco">
                {{ comunText['telefono'] }}
              </label>
              <input
                type="text"
                class="form-control"
                id="telefonoApoderado"
                formControlName="telefonoApoderado"
                [placeholder]="comunText['telefono']"
                autocomplete="off"/>
              <div *ngIf="apoderadoForm.get('telefonoApoderado')?.errors?.['minlength']"
                   class="invalid-feedback">
                {{ comunText['telefono-minlength'] }}
              </div>
              <div *ngIf="apoderadoForm.get('telefonoApoderado')?.errors?.['maxlength']"
                   class="invalid-feedback">
                {{ comunText['telefono-maxlength'] }}
              </div>
              <div *ngIf="apoderadoForm.get('telefonoApoderado')?.errors?.['pattern']"
                   class="invalid-feedback">
                {{ comunText['telefono-pattern'] }}
              </div>
            </div>
          </div>
        </div>
      </form>
      <!-- Campos adicionales -->
      <div
        *ngIf="
          formDemanding?.data?.tipoDePersona &&
          formDemanding?.data?.tipoDePersona !== ''
        ">
        <div class="row">
          <div
            class="d-flex flex-xl-row align-items-center mb-4 justify-content-between">
            <h4 class="wrapper__form__title mb-0">
              {{ mostrarParteInteresada ? dimarText['tramite-dimar']['detalle-solicitud-terceros']
              : dimarText['tramite-dimar']['detalle-solicitud-otros'] }}
            </h4>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group m-1">
              <label
                for="embarcacionMatriculada"
                class="form-label text3-tipografia-govco">
                {{ dimarText['tramite-dimar']['embarcacion-matriculada'] }}
                <span class="text-danger">*</span></label>
              <select
                class="form-control form-select"
                id="embarcacionMatriculada"
                formControlName="embarcacionMatriculada"
                [ngClass]="{
                  'is-invalid':
                    proceeding.get('embarcacionMatriculada')?.invalid &&
                    proceeding.get('embarcacionMatriculada')?.touched,
                }"
              (change)="verificar($event)">
                <option disabled selected value="">
                  {{'tramites.seleccione-opcion' | translate}}
                </option>
                <option [value]="true">
                  {{dimarText['tramite-dimar']['si']}}
                </option>
                <option [value]="false">
                  {{dimarText['tramite-dimar']['no']}}
                </option>
              </select>
              <div
                *ngIf="
                  proceeding.get('embarcacionMatriculada')?.invalid &&
                  proceeding.get('embarcacionMatriculada')?.touched
                "
                class="invalid-feedback">
                <div
                  *ngIf="
                    proceeding.get('embarcacionMatriculada')?.errors?.['required']
                  "
                  class="invalid-feedback">
                  {{'crear-administrador.campo-requerido' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group m-1">
              <label
                for="nombreEmbarcacion"
                class="form-label text3-tipografia-govco"
                >{{ dimarText['tramite-dimar']['nombre-embarcacion'] }}
              </label>
              <input
                type="text"
                class="form-control"
                id="nombreEmbarcacion"
                formControlName="nombreEmbarcacion"
                placeholder="{{ dimarText['tramite-dimar']['nombre-embarcacion'] }}"
                [ngClass]="{
                  'is-invalid':
                    proceeding.get('nombreEmbarcacion')?.invalid &&
                    proceeding.get('nombreEmbarcacion')?.touched,
                }"
                appUppercase
                autocomplete="off"/>
              <div
                *ngIf="
                  proceeding.get('nombreEmbarcacion')?.invalid &&
                  proceeding.get('nombreEmbarcacion')?.touched
                "
                class="invalid-feedback">
                <div
                  *ngIf="
                    proceeding.get('nombreEmbarcacion')?.errors?.['maxlength']
                  "
                  class="invalid-feedback">
                  {{
                    dimarText['tramite-dimar']['maxlength-nombre-embarcacion']
                  }}
                </div>
                <div
                  *ngIf="
                    proceeding.get('nombreEmbarcacion')?.errors?.['pattern']
                  "
                  class="invalid-feedback">
                  {{ comunText['razon-social-pattern'] }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="estaMatriculado">
            <div class="form-group m-1">
              <label
                for="matriculaEmbarcacion"
                class="form-label text3-tipografia-govco"
                >{{
                  dimarText['tramite-dimar']['matricula-embarcacion']
                }}</label
              >
              <input
                type="text"
                class="form-control"
                id="matriculaEmbarcacion"
                formControlName="matriculaEmbarcacion"
                [ngClass]="{
                  'is-invalid':
                    proceeding.get('matriculaEmbarcacion')?.invalid &&
                    proceeding.get('matriculaEmbarcacion')?.touched,
                }"
                appUppercase
                autocomplete="off"/>
              <div
                *ngIf="
                  proceeding.get('matriculaEmbarcacion')?.invalid &&
                  proceeding.get('matriculaEmbarcacion')?.touched
                "
                class="invalid-feedback">
                {{ dimarText['tramite-dimar']['valid-matricula-embarcacion'] }}
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="esColombiaParteInteresada || esColombiaParte">
            <div class="form-group m-1">
              <label
                for="tamanioNave"
                class="form-label text3-tipografia-govco"
              >{{
                  dimarText['tramite-dimar']['tamanio-embarcacion']
                }}</label
              >
              <select
                class="form-control form-select"
                id="tamanioNave"
                formControlName="tamanioNave"
                [ngClass]="{
                  'is-invalid':
                    proceeding.get('tamanioNave')?.invalid &&
                    proceeding.get('tamanioNave')?.touched,
                }">
                <option disabled selected value="">
                  {{'tramites.seleccione-opcion' | translate}}
                </option>
                <option *ngFor="let item of tamaniosNave" [value]="item.Id">
                  {{ item.Valor}}
                </option>
              </select>
              <div
                *ngIf="
                  proceeding.get('tamanioNave')?.invalid &&
                  proceeding.get('tamanioNave')?.touched
                "
                class="invalid-feedback">
                <div
                  *ngIf="
                    proceeding.get('tamanioNave')?.errors?.['required']
                  "
                  class="invalid-feedback">
                  {{'crear-administrador.campo-requerido' | translate}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- acta protesta -->
        <div class="row mb-3" *ngIf="!mostrarParteInteresada">
          <div class="col-md-12">
            <div class="form-group">
              <label
                for="actaProtesta"
                class="form-label text3-tipografia-govco"
                >{{ dimarText['tramite-dimar']['acta-protesta']}}
                <span class="text-danger">*</span></label
              >
              <textarea
                type="text"
                class="form-control"
                id="actaProtesta"
                formControlName="actaProtesta"
                placeholder="{{ dimarText['tramite-dimar']['acta-protesta']}}"
                [ngClass]="{
                  'is-invalid':
                    proceeding.get('actaProtesta')?.invalid &&
                    proceeding.get('actaProtesta')?.touched,
                }"
                appUppercase
                autocomplete="off"></textarea>
              <div
                *ngIf="
                  proceeding.get('actaProtesta')?.invalid &&
                  proceeding.get('actaProtesta')?.touched
                "
                class="invalid-feedback"
                [ngClass]="{
                  'is-invalid':
                    proceeding.get('actaProtesta')?.invalid &&
                    proceeding.get('actaProtesta')?.touched,
                }">
                <div
                  *ngIf="proceeding.get('actaProtesta')?.errors?.['required']"
                  class="invalid-feedback">
                  {{ dimarText['tramite-dimar']['acta-protesta-required'] }}
                </div>
                <div
                  *ngIf="proceeding.get('actaProtesta')?.errors?.['maxlength']"
                  class="invalid-feedback">
                  {{ dimarText['tramite-dimar']['maxlength-acta-protesta'] }}
                </div>
                <div
                  *ngIf="proceeding.get('actaProtesta')?.errors?.['pattern']"
                  class="invalid-feedback">
                  {{ dimarText['tramite-dimar']['acta-protesta-dimar'] }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- escrito vinculacion -->
        <div class="col-md-12" *ngIf="mostrarParteInteresada">
          <div class="form-group">
            <label
              for="escritoVinculacion"
              class="form-label text3-tipografia-govco"
            >{{ dimarText['tramite-dimar']['escrito-vinculacion']
              }}<span class="text-danger">*</span></label
            >
            <span class="govco-svg govco-info-circle" (click)="abrirModal()"></span>
            <textarea
              type="text"
              class="form-control"
              id="escritoVinculacion"
              formControlName="escritoVinculacion"
              [placeholder]="dimarText['tramite-dimar']['escrito-vinculacion']"
              [ngClass]="{
                  'is-invalid':
                    proceeding.get('escritoVinculacion')?.invalid &&
                    proceeding.get('escritoVinculacion')?.touched,
                }"
              appUppercase
              autocomplete="off"></textarea>
            <div
              *ngIf="
                  proceeding.get('escritoVinculacion')?.invalid &&
                  proceeding.get('escritoVinculacion')?.touched
                "
              class="invalid-feedback"
              [ngClass]="{
                  'is-invalid':
                    proceeding.get('escritoVinculacion')?.invalid &&
                    proceeding.get('escritoVinculacion')?.touched,
                }">
              <div
                *ngIf="proceeding.get('escritoVinculacion')?.errors?.['required']"
                class="invalid-feedback">
                {{ dimarText['tramite-dimar']['escrito-vinculacion-required'] }}
              </div>
              <div
                *ngIf="proceeding.get('escritoVinculacion')?.errors?.['maxlength']"
                class="invalid-feedback">
                {{ dimarText['tramite-dimar']['escrito-vinculacion-maxlength'] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Archivos -->
      <div class="row">
        <app-carga-archivos
          *ngIf="mostrarComponenteCarga"
          [idTipoDocumento]="idTipoDocumento"
          [archivosCargados]="archivosCargados"
          [entidadId]="entidadId"
          [idTramite]="idTramite ?? 0"
          (filesEmit)="setFilesFormValue($event)">
        </app-carga-archivos>
        <div class="mt-3 text-muted small d-flex align-items-center">
          <i class="bi bi-info-circle me-2"></i>
          {{ 'copia_envio.peso_actual' | translate:{ peso: (pesoArchivos | number:'1.3-4') } }}
        </div>
      </div>
    </div>
  </div>
  <div class="flex-row d-flex justify-content-end mt-5">
    <button
      class="btn-govco fill-before-btn-govco"
      style="width: 180px; height: 42px"
      (click)="onSubmitSave()"
      [disabled]="!validarInvestigado()"
      [attr.aria-label]="dimarText['botones-envio']['guardar-sin-enviar']">
      {{ dimarText['botones-envio']['guardar-sin-enviar'] }}
    </button>
    <button
      class="btn-govco fill-send-govco ms-2"
      style="width: 180px; height: 42px"
      (click)="onSubmit()"
      [attr.aria-label]="dimarText['botones-envio']['enviar']">
      {{ dimarText['botones-envio']['enviar'] }}
    </button>
  </div>
</div>

<!-- Modal que contiene la información del campo escrito de vinculación -->
<div class="modal-container">
  <button
    id="modalInformacion"
    #modalInformacion
    data-bs-toggle="modal"
    data-bs-target="#modalAlerta3"
    hidden="hidden"
    hidden
  aria-hidden="true"
  tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalAlerta3"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
      <div class="modal-content modal-content-govco">
        <div class="modal-header modal-header-govco modal-header-alerts-govco">
          <h5 class="modal-title h5-tipografia-govco">
            {{ 'escrito_vinculacion.titulo' | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <div class="modal-body modal-body-govco">
          <p class="form-label text3-tipografia-govco">
            {{ 'escrito_vinculacion.subtitulo' | translate }}
          </p>
          <ol type="a" class="form-label text3-tipografia-govco">
            <li>{{ 'escrito_vinculacion.punto1' | translate }}</li>
            <li>{{ 'escrito_vinculacion.punto2' | translate }}</li>
            <li>{{ 'escrito_vinculacion.punto3' | translate }}</li>
            <li>{{ 'escrito_vinculacion.punto4' | translate }}</li>
            <li>{{ 'escrito_vinculacion.punto5' | translate }}</li>
            <li>{{ 'escrito_vinculacion.punto6' | translate }}</li>
            <li>{{ 'escrito_vinculacion.punto7' | translate }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</div>
